import Vue from 'vue'
import { API_URL } from '@/config'

export const mailing_recipients = {

  namespaced: true,

  state: {
    area: {},
    persons: [],
  },

  getters: {
    area: state => state.area,
    persons: state => state.persons,
  },

  mutations: {
    toggleArea(state, area) {

      const status = state.area[area].status = !state.area[area].status;

      if (area === 'App\\Models\\Session') {
        for (let i = 0; i < state.area['App\\Models\\Session'].filters.length; i++) {
          state.area['App\\Models\\Session'].filters[i].status = status;
        }
        if (state.area['App\\Models\\Person'].status) {
          state.area['App\\Models\\SessionPerson'].status = status;
          for (let i = 0; i < state.area['App\\Models\\SessionPerson'].filters.length; i++) {
            state.area['App\\Models\\SessionPerson'].filters[i].status = status;
          }
        }
      }

      if (area === 'App\\Models\\Presentation') {
        for (let i = 0; i < state.area['App\\Models\\Presentation'].filters.length; i++) {
          state.area['App\\Models\\Presentation'].filters[i].status = status;
        }
        if (state.area['App\\Models\\Person'].status) {
          state.area['App\\Models\\PresentationPerson'].status = status;
          for (let i = 0; i < state.area['App\\Models\\PresentationPerson'].filters.length; i++) {
            state.area['App\\Models\\PresentationPerson'].filters[i].status = status;
          }
        }
      }

      if (area === 'App\\Models\\Person') {
        for (let i = 0; i < state.area['App\\Models\\Person'].filters.length; i++) {
          state.area['App\\Models\\Person'].filters[i].status = status;
        }
        if (state.area['App\\Models\\Session'].status) {
          state.area['App\\Models\\SessionPerson'].status = status;
          for (let i = 0; i < state.area['App\\Models\\SessionPerson'].filters.length; i++) {
            state.area['App\\Models\\SessionPerson'].filters[i].status = status;
          }
        }
        if (state.area['App\\Models\\Presentation'].status) {
          state.area['App\\Models\\PresentationPerson'].status = status;
          for (let i = 0; i < state.area['App\\Models\\PresentationPerson'].filters.length; i++) {
            state.area['App\\Models\\PresentationPerson'].filters[i].status = status;
          }
        }
      }

    },
    setFilters(state, options) {
      for (let model in options) {
        if (model === 'App\\Models\\Participation') {
          for (let column in options[model].filters) {
            state.area['App\\Models\\SessionPerson'].filteroptions[column] = options[model].filters[column];
            state.area['App\\Models\\PresentationPerson'].filteroptions[column] = options[model].filters[column];
          }
          continue;
        }
        for (let column in options[model].filters) {
          state.area[model].filteroptions[column] = options[model].filters[column];
        }
      }
    },
    setDays(state, days) {
      state.area['App\\Models\\Session']['filteroptions']['day_id']['options'] = days.reduce((carry, day) => carry.concat([{ 
        value: day.id, 
        label: 'day', 
        name: day.date 
      }]), []);
    },
    setRooms(state, rooms) {
      state.area['App\\Models\\Session']['filteroptions']['room_id']['options'] = rooms.reduce((carry, room) => carry.concat([{ 
        value: room.id, 
        label: 'room', 
        name: room.name 
      }]), []);
    },
    setPersons(state, persons) { state.persons = persons },
    initializeArea(state) {
      state.area = {
        'App\\Models\\Session': { status: true, filters: [], filteroptions: {} },
        'App\\Models\\SessionPerson': { status: true, filters: [], filteroptions: {} },
        'App\\Models\\Presentation': { status: true, filters: [], filteroptions: {} },
        'App\\Models\\PresentationPerson': { status: true, filters: [], filteroptions: {} },
        'App\\Models\\Person': { status: true, filters: [], filteroptions: {} },
      };
    },
    initializeFilters(state) {
      state.area['App\\Models\\Session'].filters = [
        { column: 'session_type_id', label: 'type', options: { type: false, select: false }, value: '', status: true },
      ];
      state.area['App\\Models\\SessionPerson'].filters = [
        { column: 'role_id', label: 'role', options: { type: false, select: false }, value: '', status: true },
        { column: 'state_id', label: 'participation_state', format: 'wording', options: { type: false, select: false }, value: '', status: false },
      ];
      state.area['App\\Models\\Presentation'].filters = [
        { column: 'id', label: 'id', options: { type: false }, value: '', status: true },
      ];
      state.area['App\\Models\\PresentationPerson'].filters = [
        { column: 'role_id', label: 'role', options: { type: false, select: false }, value: '', status: true },
        { column: 'state_id', label: 'participation_state', format: 'wording', options: { type: false, select: false }, value: '', status: false },
      ];
      state.area['App\\Models\\Person'].filters = [
        { column: 'last_name', label: 'last_name', options: { type: false }, value: '', status: true },
      ];
    },
  },

  actions: {

    resetFilters({ commit }) {
      commit('setPersons', []);
      commit('initializeFilters');
    },

    getFilters: () => Vue.axios.get(API_URL + '/entities', { params: {
      models: [
        'App\\Models\\Session',
        'App\\Models\\SessionPerson',
        'App\\Models\\Presentation',
        'App\\Models\\PresentationPerson',
        'App\\Models\\Participation',
        'App\\Models\\Person',
      ],
      filter_display: true,
    }}),

    getDays: () => Vue.axios.get(API_URL + '/days', { params: {
      sorts: [
        { 'column': 'days.order', 'order': 'asc'}
      ],
    }}),

    getRooms: () => Vue.axios.get(API_URL + '/rooms', { params: {
      sorts: [
        { 'column': 'rooms.order', 'order': 'asc'}
      ],
    }}),

    async getAreas({ rootState, commit, dispatch }) {
      commit('initializeArea');
      commit('setPersons', []);
      const [filters, days, rooms] = await Promise.all([
        dispatch('getFilters'),
        dispatch('getDays'),
        dispatch('getRooms')
      ]);
      commit('setProgress', false, { root: true });
      filters.data['App\\Models\\Person'].filters.country_code.options = filters.data['App\\Models\\Person'].filters.country_code.options.sort((a, b) => rootState._[a.name].localeCompare(rootState._[b.name]));
      commit('setFilters', filters.data);
      commit('setDays', days.data.items);
      commit('setRooms', rooms.data.items);
      commit('initializeFilters');
    },

    async getPersons({ rootState, state, getters, commit }) {

      let active = false;
      if (state.area['App\\Models\\Session'].status) active = true;
      if (state.area['App\\Models\\Presentation'].status) active = true;
      if (state.area['App\\Models\\Person'].status) active = true;
      if (!active) return;

      if (rootState.progress) return;

      let ids = rootState.mailing.mailing.mailing_persons.reduce((carry, recipient) => {
        carry.push(recipient.id);
        return carry;
      }, []);

      const areas = {};
      Object.keys(getters.area).forEach(area => {
        const filters = getters.area[area].filters.map(filter => {
          return {
            column: filter.column,
            operator: filter.operator,
            status: filter.status,
            value: filter.value,
          }
        });
        areas[area] = {
          filters: filters,
          sorts: getters.area[area].sorts,
          status: getters.area[area].status,
        };
      });

      const persons = await Vue.axios.post(API_URL + '/recipients', {
        areas: areas,
        exclude: ids,
        limitless: true,
      })
      commit('setProgress', false, { root: true });
      commit('setPersons', persons.data);
    },

  }
}
